export { EmailShareButton, EmailIcon } from "react-share";
